import $ from 'jquery'
import { Component } from 'preact'
import ButtonControl from '../button-control'

class WebmasterCandidate extends Component {
  constructor (props) {
    super()
    this.state = { email: props.email, sendLoading: false, deleteLoading: false, error: null }
    this.csrfToken = document.getElementById('csrftoken').value
  }

  sendEmail () {
    if (this.state.email) {
      this.setState({ sendLoading: true })
      $.post(
        '/settings/emailManagement/sendVerificationMail',
        { email: this.state.email, yip_csrf_token: this.csrfToken }
      ).then(function () {
        this.setState({ sendLoading: false })
        window.location.reload()
      }.bind(this)).fail(function (r) {
        this.setState({ sendLoading: false, error: r.responseJSON.error })
      }.bind(this))
    }
  }

  deleteEmail () {
    this.setState({ deleteLoading: true })
    $.post(
      '/settings/emailManagement/deleteCandidate',
      { email: this.props.email, yip_csrf_token: this.csrfToken }
    ).fail(function () {
      this.setState({ deleteLoading: false, error: 'Something went wrong. Please, refresh the page and try again.' })
    }.bind(this)).then(function () {
      this.setState({ deleteLoading: false })
      this.props.onDelete()
    }.bind(this))
  }

  render (props, state) {
    return <WebmasterCandidateComponent
      {...state}
      {...props}
      email={props.email || state.email}
      onChange={(val) => this.setState({ email: val })}
      sendVerificationEmail={() => this.sendEmail()}
      deleteEmail={() => this.deleteEmail()}
    />
  }
}

const WebmasterCandidateComponent = (props) => <div class='item row'>
  { props.error ? <div class='alert alert-danger'>{props.error}</div> : null }
  <input id='email' class='js-email' type='email' placeholder='info@example.com' value={props.email} onChange={(e) => props.onChange(e.target.value)} />
  { props.showSendButton ? <ButtonControl variant='success' title='Send verification mail' isLoading={props.sendLoading} onClick={props.sendVerificationEmail} /> : null }
  { props.showDeleteButton ? <ButtonControl variant='danger' title='Delete email-address' isLoading={props.deleteLoading} onClick={props.deleteEmail} /> : null }
</div>

export { WebmasterCandidateComponent }
export default WebmasterCandidate
